import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { backendUrl } from 'src/environments/environment';
import { toPromise } from './toPromise';

export interface CategoryResponse {
  status: number;
  data: Array<Category>;
}
export interface CategoryData {
  status: number;
  data: Category;
}
export interface Category {
  id: number;
  name: string;
  parent: number;
  primary_color: string;
  secondary_color: string;
  background_img: string;
  icon_img: string;
  trending_search_count: number;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  child_category: Array<Category>;
  name_pt: string;
  slug: string;
}
@Injectable({
  providedIn: 'root',
})
export class CategoryStore {
  constructor(private httpClient: HttpClient) {}

  async getCategory(
    type: boolean = false,
    isSubCat = false
  ): Promise<CategoryResponse> {
    let param = { child_category: 1 };
    const url = type ? `${backendUrl}seller/category` : `${backendUrl}category?child_category=1 `;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<CategoryResponse>(url, {
        params: isSubCat ? param : null,
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async getSubCategory(params = null): Promise<CategoryResponse> {
    const param = {
      category_parent: params,
    };
    const url = `${backendUrl}category`;
    return toPromise(
      this.httpClient.get<CategoryResponse>(url, {
        params: param,
      })
    );
  }

  async getCategoryDetail(categoryId: number): Promise<CategoryData> {
    const url = `${backendUrl}category/${categoryId}`;
    return toPromise(
      this.httpClient.get<CategoryData>(url, {
        params: {},
      })
    );
  }

  async getCategoryList(): Promise<CategoryResponse> {
    const url = `${backendUrl}all-category`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<CategoryResponse>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async getSubCategoryList(): Promise<CategoryResponse> {
    const url = `${backendUrl}all-sub-category`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<CategoryResponse>(url, {
        params: {},
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

}
